import { render, staticRenderFns } from "./switchOff.vue?vue&type=template&id=0b68076c"
import script from "./switchOff.vue?vue&type=script&lang=js"
export * from "./switchOff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports